import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { AlertTriangle, X } from 'lucide-react';
import { Banner } from '@/components/ui/banner';
import { Button } from '@/components/ui/button';
import { useHasUnhealthyCalendarConnections } from '@/hooks/queries';

const SESSION_KEY = 'calendar-sync-banner-dismissed';

export function CalendarSyncBanner() {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(SESSION_KEY) === 'true',
  );

  const hasUnhealthy = useHasUnhealthyCalendarConnections();

  if (dismissed || !hasUnhealthy) return null;

  const handleDismiss = () => {
    sessionStorage.setItem(SESSION_KEY, 'true');
    setDismissed(true);
  };

  const handleFix = () => {
    navigate({ to: '/app/settings' });
  };

  return (
    <Banner variant="warning">
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span className="text-sm font-medium">
        Calendar sync interrupted — reconnect your accounts to keep events up to date.
      </span>
      <div className="flex-1" />
      <Button
        size="sm"
        variant="ghost"
        className="text-white hover:bg-white/20 h-7 text-xs"
        onClick={handleFix}
      >
        Fix Now
      </Button>
      <button
        onClick={handleDismiss}
        className="p-1 hover:bg-white/20 rounded transition-colors"
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>
    </Banner>
  );
}
